import 'regenerator-runtime/runtime'

import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'

import TimeAgo from 'javascript-time-ago'

import en from 'javascript-time-ago/locale/en.json'

TimeAgo.addDefaultLocale(en)

const container = document.getElementById('root')
if (container == null) {
  throw new Error('no pad element')
}

const root = createRoot(container)
root.render(<App />)
